// =============================================
// constants
export const constants = {
  SET_PROFILE: 'app/SET_PROFILE'
} as const
